import { render, staticRenderFns } from "./sg-list.html?vue&type=template&id=2de27fb0&scoped=true&external"
import script from "./sg-list.js?vue&type=script&lang=js&external"
export * from "./sg-list.js?vue&type=script&lang=js&external"
import style0 from "./sg-list.scss?vue&type=style&index=0&id=2de27fb0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de27fb0",
  null
  
)

export default component.exports